import {
  getFirebaseBackend
} from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
} from "../../../helpers/fakebackend_helper";
import {
  createAsyncThunk
} from '@reduxjs/toolkit';
import axios from 'axios';

import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag
} from './reducer';
import {
  useNavigate
} from "react-router-dom";
import { API_ENDPOINTS } from "../../../constants/apiEndPoints";

export const loginUser = (user, history) => async (dispatch) => {
  const navigate = useNavigate();
  console.log(user);
  try {
    let response;
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      let fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.loginUser(user.email, user.password);
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = postJwtLogin({
        email: user.email,
        password: user.password
      });
    } else if (process.env.REACT_APP_DEFAULTAUTH) {
      response = postFakeLogin({
        email: user.email,
        password: user.password
      });
    }

    var data = await response;

    if (data) {
      localStorage.setItem("authUser", JSON.stringify(data));
      if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        var finallogin = JSON.stringify(data);
        finallogin = JSON.parse(finallogin);
        data = finallogin.data;
        if (finallogin.status === "success" || (finallogin.username && finallogin.password)) {
          dispatch(loginSuccess(data));
          history("/dashboard");
        } else {
          history("/login");
          dispatch(apiError(finallogin));
        }
      } else {
        dispatch(loginSuccess(data));
        history("/dashboard");
      }
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    localStorage.removeItem("authUser");
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      let fireBaseBackend = getFirebaseBackend();
      const response = fireBaseBackend.logout();
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    // else {
    //   response = postSocialLogin(data);
    // }

    const socialdata = await response;
    if (socialdata) {
      localStorage.setItem("authUser", JSON.stringify(socialdata));
      dispatch(loginSuccess(socialdata));
      history('/dashboard');
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const requestOtp = createAsyncThunk('login', async (phoneNumber, thunkAPI) => {
  try {
    
    const data = await axios.post(API_ENDPOINTS.AUTH.LOGIN, {
      phone: phoneNumber,
      "country_code": "+91"
    });
    
    if (data.data) {
      // localStorage.setItem("authUser", JSON.stringify(data));
      // dispatch(loginSuccess(response));
      // history("/dashboard");
      data.response={...data.data,phoneNumber}
    }
    console.log('response.data',data.response);
    return data.response;
  } catch (error) {
    console.log(error)
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const verifyOtp = createAsyncThunk('auth/verifyOtp', async ({
  email,
  otp
}, thunkAPI) => {
  try {
    const response = await axios.post(API_ENDPOINTS.AUTH.VERIFY_OTP, {
      email,
      otp
    });
    alert('')
    // navigate('/multi-step-form')
    // console.log('response.data',response.data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error))
  }
};